/**
 * Fetch
 * @author jiakaiguang
 * @time 2019/07/16
 */
import axios from 'axios'
import { getCookieByName } from '../generic/common'

const env = process.env.NODE_ENV
const platform = '97ae2982356f69d8'

const URL_PROD_INNER = 'http://api-kpp.qiyi.domain'
const URL_PROD_OUTER = '//api-kpp.if.iqiyi.com'

// 开发模式中，可在.env.development中设定
// VUE_APP_URL_TEST_INNER 以及 VUE_APP_URL_TEST_OUTER
// const URL_TEST_INNER = process.env.VUE_APP_URL_TEST_INNER || 'http://test-kpp.qiyi.domain'
// const URL_TEST_OUTER = process.env.VUE_APP_URL_TEST_OUTER || 'http://test-kpp.qiyi.domain'

const URL_TEST_INNER = 'http://test-kpp.qiyi.domain'
const URL_TEST_OUTER = 'http://test-kpp.qiyi.domain'

const defaults = {
  baseURL: '',
  basePath: '',
  headers: {},
  auth: {}
}

class Fetch {
  constructor() {
    this.option = defaults
    this.req = null // node request
    this.app = null // nuxt app

    this.axiosInstance = axios.create({
      timeout: 10000,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      }

      // transformResponse: [function(data) {
      // 	return JSON.parse(data);
      // }],

      // validateStatus: function (status) {
      // 	return status >= 200 && status < 300
      // }
    })

    this.addDefaultRequestInterceptor()

    this.addDefaultResponseInterceptor()
  }

  addRequestInterceptor(func) {
    this.axiosInstance.interceptors.request.use(func)
  }

  addResponseInterceptor(func) {
    this.axiosInstance.interceptors.response.use(func)
  }

  /**
   * default interceptor for request
   */
  addDefaultRequestInterceptor() {
    this.axiosInstance.interceptors.request.use(
      (config) => {
        const p00001 = getCookieByName('P00001', document.cookie)

        // headers
        /* eslint prefer-object-spread: "off" */
        config.headers = Object.assign(
          {},
          {
            P00001: p00001 || 'default-h5-authcookie',
            platform
          },
          config.headers
        )

        return config
      },
      (err) => {
        return Promise.reject(err)
      }
    )
  }

  /**
   * default interceptor for response
   */
  addDefaultResponseInterceptor() {
    this.axiosInstance.interceptors.response.use(
      (res) => {
        const { data } = res
        if (data.resultCode !== 'A00000' && data.resultCode !== 'A00004') {
          return Promise.reject({
            status: data.resultCode,
            body: data.data,
            message: data.resultMsg
          })
        }
        return data.data
      },
      (err) => {
        let errorMessage = err.message
        let status = -1
        if (err.response) {
          status = err.response.status
          switch (err.response.status) {
            case 404: {
              errorMessage = '404 not found'
              break
            }
            case 500: {
              errorMessage = '500 internal error'
              break
            }
            default:
              break
          }
        }
        return Promise.reject({
          status,
          body: null,
          message: errorMessage
        })
      }
    )
  }

  setRequestBaseURL(baseURL) {
    this.option.baseURL = baseURL
  }

  setRequestBasePath(basePath) {
    this.option.basePath = basePath
  }

  setRequestOption(option) {
    if (option.headers) {
      this.addRequestHeaders(option.headers)
      delete option.headers
    }
    Object.assign(this.option, option)
  }

  addRequestHeaders(headers = {}) {
    this.option.headers = Object.assign({}, this.option.headers, headers)
  }

  getRequestHeaders() {
    return this.option.headers
  }

  raw(option) {
    return axios(option)
  }

  request(option, req) {
    this.req = req

    const isServer = typeof window === 'undefined'
    let baseURL

    if (isServer) {
      // 内网域名
      if (env === 'development') {
        baseURL = URL_TEST_INNER
      } else {
        baseURL = URL_PROD_INNER
      }
    } else if (env === 'development') {
      baseURL = URL_TEST_OUTER
    } else {
      baseURL = URL_PROD_OUTER
    }

    this.setRequestBaseURL(baseURL)

    option.params = option.params || {}
    option.headers = option.headers || {}
    // fix 浏览器返回键，get请求不发的问题
    // if (option.method === "get") {
    //   option.params.__t__ = Date.now();
    // }

    option.url = `${this.option.baseURL}${this.option.basePath}${option.url}`
    return this.axiosInstance(option)
  }

  get(url, params = {}, headers = {}, req) {
    return this.request({ method: 'get', url, params, headers }, req)
  }

  post(url, params = {}, headers = {}, req) {
    return this.request({ method: 'post', url, data: params, headers }, req)
  }

  put(url, params = {}, headers = {}, req) {
    return this.request({ method: 'put', url, data: params, headers }, req)
  }

  patch(url, params = {}, headers = {}, req) {
    return this.request({ method: 'patch', url, data: params, headers }, req)
  }

  delete(url, params = {}, headers = {}, req) {
    return this.request({ method: 'delete', url, data: params, headers }, req)
  }
}

export default {
  install(Vue) {
    const fetch = new Fetch()
    fetch.setRequestBasePath('/api')
    Vue.prototype.$fetch = fetch
  }
}
